import React, { useState } from 'react';
import { MetaTags } from 'react-meta-tags';
//import Breadcrumbs
import { DashBreadcrumb } from '../../../components/Common/Breadcrumb';
import 'react-drawer/lib/react-drawer.css';
import {
  Col,
  Container,
  Row,
  Spinner,
} from 'reactstrap';
import { Toaster } from 'react-hot-toast';
import ManageComplaintsList from './components/ManageComplaintsList';
import CreateComplaintOffcanvas from './components/CreateComplaintOffcanvas';

const ManageComplaints = () => {

  const users = JSON.parse(localStorage?.getItem('authUser'));

  const [loading, setLoading] = useState(false);
  const [stores, setStores] = useState();
  const [showCreateComplaint, setShowCreateComplaint] = useState(false);
  const [refreshList, setRefreshList] = useState(false);
  const toggleCreateComplaint = () => setShowCreateComplaint((prev) => !prev);
  const handleComplaintCreated = () => {
    setRefreshList((prev) => !prev);
  };

  return (
    <React.Fragment>
      {loading ? (
        <div className="loader-container">
          <Spinner type="grow" className="ms-2" color="dark" />
        </div>
      ) : (
        <></>
      )}
      <div className="page-content refundOrder">
        <MetaTags>
          <title>Manage Complaints</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Row>
            <Col>
              <DashBreadcrumb
                title="Complaints"
                breadcrumbItem="Manage Complaints List"
              />
            </Col>
             <Col xl={6}>
              <Row className="align-items-end">
                <Col xl={12} className="textAlignRigh">
                  <div className="DashbordFliter ">
                      <button
                        type="button"
                        className="btn btn-dark"
                        onClick={toggleCreateComplaint}
                      >
                        Create Request
                      </button>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <ManageComplaintsList stores={stores} refreshList={refreshList} />
          <CreateComplaintOffcanvas isOpen={showCreateComplaint} toggle={toggleCreateComplaint} users={users} onComplaintCreated={handleComplaintCreated} />
        </Container>
      </div>
      <Toaster position="top-right" reverseOrder={false} />
    </React.Fragment>
  );
};

export default ManageComplaints;
